import { render, staticRenderFns } from "./PppElementsList.vue?vue&type=template&id=134b57c3"
import script from "./PppElementsList.vue?vue&type=script&lang=js"
export * from "./PppElementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports